import React from "react";

import { secondsToTimeText, timestampToTime } from "../../utils/GeneralUtils";

import styles from "./singleeventtitle.module.scss";

type Props = {
  start_date?: number;
  end_date?: number;
  start_time?: number;
  end_time?: number;
};
const SingleEventTitle: React.FC<Props> = ({
  start_date,
  end_date,
  start_time,
  end_time,
}) => {
  return (
    <div className={styles["single-event_header"]}>
      <div className={styles["single-event__date"]}>
        <div className={styles["single-event__date-deco"]}>
          <span>DATE</span>
        </div>
        <div className={styles["single-event__date-data"]}>
          <div
            className={`${styles["single-event__date-big"]} ${styles["animated"]}`}
          >
            <span>
              {start_date ? `${timestampToTime(start_date, false)}` : null}
            </span>
          </div>
          <div className={styles["single-event__date-detail-area"]}>
            <div className={styles["single-event__date-detail"]}>
              <div>START</div>
              {start_date
                ? `${timestampToTime(start_date, false)} ${secondsToTimeText(
                    start_time
                  )}`
                : null}
            </div>
            <div className={styles["single-event__date-detail"]}>
              <div>END</div>
              {end_date
                ? `${timestampToTime(end_date, false)} ${secondsToTimeText(
                    end_time
                  )}`
                : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleEventTitle;
